export default __webpack_public_path__ + "static/media/Historia.2327e520.png";